// extracted by mini-css-extract-plugin
export default {"Input":"input_Input__cz7mm"};